<template>
  <v-container class="py-12">
    <v-row>
      <v-col :cols="12">
        <div class="title-container">
          <div class="title-block">
            <span id="title" class="page-title">{{ page.title }}</span>
            <v-breadcrumbs
              class="app-breadcrumb"
              divider="›"
              :items="[
                {
                  text: 'Home',
                  disabled: false,
                  to: '/home',
                  exact: true
                },
                {
                  text: 'Intervalos',
                  disabled: false,
                  to: '/intervalos',
                  exact: true
                },
                {
                  text: 'Novo',
                  disabled: true,
                  exact: true
                }
              ]"
            ></v-breadcrumbs>
          </div>
          <div class="button-group" style="padding-right: 16px;">
            <v-btn
              id="btnSave"
              type="button"
              elevation="0"
              color="primary"
              dark
              @click="add"
              :loading="dataset.loading"
              v-if="page.isNew"
              >Salvar</v-btn
            >
            <v-btn
              id="btnSave"
              type="button"
              elevation="0"
              color="primary"
              dark
              @click="update"
              :loading="dataset.loading"
              v-if="!page.isNew"
              >Atualizar</v-btn
            >
            <v-btn
              id="btnBack"
              type="button"
              elevation="0"
              color="primary"
              outlined
              to="/intervalos"
              >Voltar</v-btn
            >
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="form-card">
          <v-card-text>
            <v-form ref="form" id="locationForm" @submit.prevent="add">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="dataset.data.init_time"
                    label="Horário de início"
                    :rules="[$rules.required]"
                    outlined
                    dense
                    hide-details="auto"
                    type="time"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="dataset.data.end_time"
                    label="Horário de término"
                    :rules="[$rules.required]"
                    outlined
                    dense
                    hide-details="auto"
                    type="time"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  name: 'IntervalCreate',
  data: () => ({
    page: {
      isNew: false,
      title: ''
    },
    dataset: {
      data: {},
      loading: false
    }
  }),

  created() {
    this.loadData()
  },

  methods: {
    goBack() {
      this.$router.replace('/intervalos')
    },

    async loadData() {
      this.setPage()
      this.listBreadCrumbItems()

      await this.load()
    },

    setPage() {
      this.page.isNew = this.$route.params.id == 'novo'
      this.page.title = this.page.isNew ? 'Novo intervalo' : 'Detalhes do intervalo'
    },

    listBreadCrumbItems() {
      this.dataset.breadcrumbItems = [
        {
          text: 'Homepage',
          disabled: false,
          to: '/home',
          exact: true
        }
      ]

      this.dataset.breadcrumbItems.push({
        text: 'Intervalos',
        disabled: false,
        to: '/intervalos',
        exact: true
      })

      this.dataset.breadcrumbItems.push({
        text: this.page.isNew ? 'Incluir intervalo' : 'Detalhes do intervalo',
        disabled: true,
        exact: true
      })
    },

    async load() {
      if (this.page.isNew) return

      this.dataset.loading = true

      try {
        const result = await axios.get(`/api/v2/time-intervals/${this.$route.params.id}`)

        this.dataset.data = result.data.content.data
      } catch (error) {
        this.$dialog.notify.error(
          'Ocorreu um erro ao encontrar as informações do intervalo, tente novamente!',
          {
            position: 'top-right',
            timeout: 2000
          }
        )
      } finally {
        this.dataset.loading = false
      }
    },

    async add() {
      if (!this.$refs.form.validate()) return

      const proceedAction = await this.$dialog.confirm({
        text: 'Deseja salvar o intervalo?',
        title: 'Salvar intervalo',
        actions: {
          false: 'Cancelar',
          true: 'Salvar'
        }
      })

      if (!proceedAction) return

      this.dataset.loading = true

      const payload = this.buildPayload()

      try {
        const response = await axios.post(`/api/v2/time-intervals`, payload, {
          config: { headers: { 'Content-Type': 'application/json' } }
        })

        this.$dialog.notify.info('Intervalo salvo com sucesso', {
          position: 'top-right',
          timeout: 2000
        })

        this.goBack()
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 2000
        })
      } finally {
        this.dataset.loading = false
      }
    },

    async update() {
      if (!this.$refs.form.validate()) return

      const proceedAction = await this.$dialog.confirm({
        text: 'Deseja atualizar o intervalo?',
        title: 'Atualizar intervalo',
        actions: {
          false: 'Cancelar',
          true: 'Atualizar'
        }
      })

      if (!proceedAction) return

      this.dataset.loading = true

      const payload = this.buildPayload()

      try {
        const response = await axios.patch(
          `/api/v2/time-intervals/${this.$route.params.id}`,
          payload,
          { config: { headers: { 'Content-Type': 'application/json' } } }
        )

        this.$dialog.notify.info('Intervalo salvo com sucesso', {
          position: 'top-right',
          timeout: 2000
        })

        this.goBack()
      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 2000
        })
      } finally {
        this.dataset.loading = false
      }
    },

    buildPayload() {
      const data = {
        init_time: this.dataset.data.init_time,
        end_time: this.dataset.data.end_time
      }

      return data
    }
  }
}
</script>
